import { useHasAccess } from 'lib-shared-access-control';

import { flowsApi } from 'apis/flows';

/**
 * A hook that checks whether the business hours feature in Analytics should be
 * enabled, based on feature flag state, user role and whether the organization
 * has at least one business hours schedule created.
 */
export const useHasAnalyticsBusinessHours = (): boolean => {
  const hasBusinessHoursAccess = useHasAccess('settings.business_hours');

  const { data } = flowsApi.useReadFlowsSchedulesQuery(
    { limit: 1 },
    {
      skip: !hasBusinessHoursAccess,
    },
  );

  const hasBusinessHours =
    hasBusinessHoursAccess && !!data?.data.total_number_of_schedules;

  return hasBusinessHours;
};
